import { useEffect } from 'react';
import './FloralHealingAnimation.css';

export default function FloralHealingAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl) return;

    const container = playerEl.closest('.battle-screen') || playerEl.closest('.battle-container') || document.body;
    const containerRect = container.getBoundingClientRect();

    const playerRect = playerEl.getBoundingClientRect();
    const playerX = Math.round((playerRect.left + playerRect.width / 2) - containerRect.left);
    const playerY = Math.round((playerRect.top + playerRect.height / 2) - containerRect.top);

    const elements = [];

    playerEl.classList.add('floral-healing-user-channel');

    const glow = document.createElement('div');
    glow.className = 'floral-healing-glow';
    glow.style.left = `${playerX - 90}px`;
    glow.style.top = `${playerY - 90}px`;
    glow.style.width = '180px';
    glow.style.height = '180px';
    container.appendChild(glow);
    elements.push(glow);

    const bloomCore = document.createElement('div');
    bloomCore.className = 'floral-healing-bloom-core';
    bloomCore.style.left = `${playerX - 36}px`;
    bloomCore.style.top = `${playerY - 36}px`;
    bloomCore.style.width = '72px';
    bloomCore.style.height = '72px';
    container.appendChild(bloomCore);
    elements.push(bloomCore);

    for (let i = 0; i < 14; i++) {
      const petal = document.createElement('div');
      petal.className = 'floral-healing-petal-orbit';
      const angle = (i / 14) * 360;
      const radius = 70 + (i % 3) * 8;
      const x = playerX + Math.cos(angle * Math.PI / 180) * radius;
      const y = playerY + Math.sin(angle * Math.PI / 180) * radius;
      petal.style.left = `${x - 10}px`;
      petal.style.top = `${y - 10}px`;
      petal.style.animationDelay = `${i * 35}ms`;
      petal.textContent = '🌸';
      container.appendChild(petal);
      elements.push(petal);
    }

    const phase2Timer = setTimeout(() => {
      playerEl.classList.remove('floral-healing-user-channel');
      playerEl.classList.add('floral-healing-user-bloom');

      for (let i = 0; i < 4; i++) {
        const ring = document.createElement('div');
        ring.className = 'floral-healing-heal-ring';
        ring.style.left = `${playerX - 100}px`;
        ring.style.top = `${playerY - 100}px`;
        ring.style.width = '200px';
        ring.style.height = '200px';
        ring.style.animationDelay = `${i * 120}ms`;
        container.appendChild(ring);
        elements.push(ring);
      }

      for (let i = 0; i < 14; i++) {
        const pollen = document.createElement('div');
        pollen.className = 'floral-healing-pollen';
        const px = playerX + (Math.random() - 0.5) * 80;
        const py = playerY + (Math.random() - 0.5) * 60;
        pollen.style.left = `${px - 4}px`;
        pollen.style.top = `${py - 4}px`;
        pollen.style.animationDelay = `${i * 40}ms`;
        pollen.textContent = '✨';
        container.appendChild(pollen);
        elements.push(pollen);
      }
    }, 600);
    elements.push({ timer: phase2Timer, type: 'timer' });

    const phase3Timer = setTimeout(() => {
      for (let i = 0; i < 10; i++) {
        const leaf = document.createElement('div');
        leaf.className = 'floral-healing-leaf-sparkle';
        const ang = (i / 10) * 360;
        const r = 60 + Math.random() * 30;
        const lx = playerX + Math.cos(ang * Math.PI / 180) * r;
        const ly = playerY + Math.sin(ang * Math.PI / 180) * r;
        leaf.style.left = `${lx - 6}px`;
        leaf.style.top = `${ly - 6}px`;
        leaf.style.animationDelay = `${i * 45}ms`;
        leaf.textContent = '🍃';
        container.appendChild(leaf);
        elements.push(leaf);
      }

      for (let i = 0; i < 6; i++) {
        const heart = document.createElement('div');
        heart.className = 'floral-healing-heart';
        const hx = playerX + (Math.random() - 0.5) * 60;
        const hy = playerY + (Math.random() - 0.5) * 50;
        heart.style.left = `${hx - 6}px`;
        heart.style.top = `${hy - 6}px`;
        heart.style.animationDelay = `${i * 60}ms`;
        heart.textContent = '💚';
        container.appendChild(heart);
        elements.push(heart);
      }
    }, 1100);
    elements.push({ timer: phase3Timer, type: 'timer' });

    const phase4Timer = setTimeout(() => {
      playerEl.classList.remove('floral-healing-user-bloom');
      const afterglow = document.createElement('div');
      afterglow.className = 'floral-healing-afterglow';
      afterglow.style.left = `${playerX - 70}px`;
      afterglow.style.top = `${playerY - 70}px`;
      afterglow.style.width = '140px';
      afterglow.style.height = '140px';
      container.appendChild(afterglow);
      elements.push(afterglow);
    }, 1500);
    elements.push({ timer: phase4Timer, type: 'timer' });

    const cleanupTimer = setTimeout(() => {
      playerEl.classList.remove('floral-healing-user-channel', 'floral-healing-user-bloom');
      elements.forEach(item => {
        if (item.type === 'timer') {
          clearTimeout(item.timer);
        } else if (item && item.parentNode) {
          item.remove();
        }
      });
      onComplete();
    }, 1900);

    return () => {
      clearTimeout(cleanupTimer);
      playerEl.classList.remove('floral-healing-user-channel', 'floral-healing-user-bloom');
      elements.forEach(item => {
        if (item.type === 'timer') {
          clearTimeout(item.timer);
        } else if (item && item.parentNode) {
          item.remove();
        }
      });
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

FloralHealingAnimation.moveType = 'fairy';
